import { gql } from 'graphql-request'

export namespace BlockReasonQueries {
  export const QUERY_KEY = 'getBlockReasons'

  export function getBlockReasons() {
    return gql`
      {
        blockReasons(limit: 100) {
          description
          hierarchy
          id
        }
      }
    `
  }
}
